import React, { useContext } from 'react';
import { ICustomersContext, CustomersContext } from '../../../../customersState/customersContext';
import Text from 'components/Text/Text';
import { Item } from './components/Item';
import classNames from 'classnames';
import style from './ArchivedCustomersList.module.scss';

export const ArchivedCustomersList: React.FC = () => {
	const { customers } = useContext<ICustomersContext>(CustomersContext);

	const nameHeadingClasses = classNames(style.name, style.heading);
	const archivingDateHeadingClasses = classNames(style.archivingDate, style.heading);
	const userHeadingClasses = classNames(style.user, style.heading);
	const actionHeadingClasses = classNames(style.action, style.heading);

	return (
		<div className={style.container} data-test="ArchivedCustomersList">
			<div className={style.tableHeaders}>
				<Text
					className={nameHeadingClasses}
					translationNameSpace="listing"
					translationKey="nameLabel"
					withTooltip={true}
					isNewTooltip={true}
				/>
				<Text
					className={archivingDateHeadingClasses}
					translationNameSpace="listing"
					translationKey="archivingDateLabel"
					withTooltip={true}
					isNewTooltip={true}
				/>
				<Text
					className={userHeadingClasses}
					translationNameSpace="listing"
					translationKey="userLabel"
					withTooltip={true}
					isNewTooltip={true}
				/>
				<Text
					className={actionHeadingClasses}
					translationNameSpace="listing"
					translationKey="actionLabel"
					withTooltip={true}
					isNewTooltip={true}
				/>
			</div>
			{customers.customers.map((item, index) => (
				<Item data={item} key={item.id} index={index} />
			))}
		</div>
	);
};
